import { Injectable } from '@angular/core';
import {  Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }


  /**
  * @description Rolefinder get current user details from localstorge and
  * check wheter user is Admin, Manger, Employee then return result accordingly.
  */
  roleFinder() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!!currentUser.roles.includes("admin")) {
      return 'admin';
    }
    if (currentUser.roles.includes("manager")) {
      return 'manager';
    }
    if (currentUser.roles.includes("employee")) {
      return 'employee';
    }
  }

  /* Getting Headers */
  private getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid'),
      'Access-Control-Allow-Origin': '*'
    });
  }

  interviewSchedule(): Observable<any> {
    let params = new HttpParams().set('email', localStorage.getItem('uid'));
    return this.http.get(`${environment.ahr_url}/weekly_schedule_report`, { headers: this.getHeaders(), params: params }).pipe(
      map(res => res)
    )
  }

  holidays(dept): Observable<any> {
    let query = 'department='+ dept;
    return this.http.get(environment.ahr_url+'/holidays?'+ query, {headers: this.getHeaders().set('Accept', 'application/json')});
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/services/dashboard/dashboard.service.ts